<template>
    <rkm-modal
        :buttons="['cancel']"
        :loading="loading"
        :title="title"
        large
        ref="Modal"
    >
        <rkm-alert
            v-if="cid"
            class="mb-3"
        >
            <span>
                <strong>CID Principal:</strong> {{ cid.codigo | formatCid }} - {{ cid.nome }}
            </span>
        </rkm-alert>

        <List
            :cid-id="cid ? cid.id : null"
            :registro="registro"
            :only-with-cid="onlyWithCid"
            @select="handleSelect"
            ref="Form"
        />
    </rkm-modal>
</template>

<script>
// Components.
import List from './List'

// Vuex.
import { mapGetters } from 'vuex'

import formats from '@/filters/formats'

export default {
    components: { List },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        cid: null,
        registro: null,
        onlyWithCid: false,
    }),
    filters: {
        formatCid: formats.formatCid
    },
    methods: {
        open(params = {}) {

            if ('cid' in params) {

                this.cid = params.cid
            }

            if ('registro' in params) {

                this.registro = params.registro
            }

            if ('onlyWithCid' in params) {

                this.onlyWithCid = params.onlyWithCid
            }

            this.$refs.Modal.show()
        },
        handleSelect(procedimento) {

            this.$emit('select', procedimento)

            this.$refs.Modal.hide()
        },
    },
    props: {
        title: { type: String, default: 'Busca de procedimento' }
    }
}
</script>